var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2V1H5V2H2.50009V3H9.50009V2H7ZM9.49997 8.00001H2.49997V6.00001H1.49997V8.00001V9.00001L3.99987 9.00001V11H4.99987V9.00001H6.99992V10H5V11H6.99992V11H7.99992V9.00001L10.5 9.00001V8.00001H10.5V6.00001H9.50002V3H8.50002V7H9.49997V8.00001ZM2.50009 3V7H3.50009V3H2.50009Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationS);
export default __webpack_public_path__ + "static/media/notification-s.267451e68e1904143c1408918ef70dbf.svg";
export { ForwardRef as ReactComponent };